
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Vant from 'vant';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/Css.css'
import './assets/iconfont/iconfont.css'
import 'vant/lib/index.css';
import api from './axios_api/index.js'

Vue.prototype.$api = api

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);
// 用于忽略标签wx-open-launch-weapp （联通实名）
Vue.config.ignoredElements = ['wx-open-launch-weapp']

//全局方法
import common from './assets/common.js'
Vue.prototype.$common = common

router.beforeEach((to,from,next)=>{
  let token = to.query.token;
  if(to.path == '/userCenter' || to.path == '/userBind'){
    axios({
      method: 'post',
      url: 'apis/wechat/wechatUserInfo/checkWechatBind',
      data: {token:token},
    })
    .then(function (res) {
      if(to.path == '/userCenter'&& from.path  == '/userBind') {
        if(res.data.code == 200){
          next()
        }else{
          next({path: '/userBind',query: {token:common.getParams(window.location.href).token}})
        }
      }else if((to.path == '/userBind' && from.path  == '/userCenter')){
        if(res.data.code == 200){
          next({path: '/userCenter',query: {userName:res.data.data,token:common.getParams(window.location.href).token}})
        }else{
          next()
        }
      }else{
        next()
      }
    })
  }else{
    next()
  }
  if(to.path == '/userCenter' || to.path == '/quickQuery'){
    document.cookie = "kas=" + '';
    document.cookie = "kaids=" + '' ;
    localStorage.removeItem('kaco')
    next()
  }else{
    next()
  }
  //判断是否从查询历史跳往
  if((from.path == '/Record' || from.path == '/') && to.path == '/sms'){
    document.cookie = "isfrom=" + '1';
    next()
  }else{
    next()
  }
})
window.Vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js